import {
  Button,
  Flex,
  IconButton,
  Input,
  InputNumber,
  Paper,
  Select,
  Text,
} from "@pillar-ui/core";
import { Close } from "@pillar-ui/icons";
import { createPortal } from "react-dom";
import { RESTAURANT_TYPE, RESTAURANT_TYPE_OPTIONS } from "../common/constants";
import {
  DIALOG_MAX_HEIGHT,
  DIALOG_MAX_WIDTH,
  DIALOG_MIN_HEIGHT,
} from "../styles/variables";
import { useEffect, useState } from "react";
import { createOrUpdateRestaurant } from "../services";
import { useAppStateContext } from "../common/contexts";

const RestaurantEditor = (props) => {
  const { open, onClose, restaurantEditorData } = props;
  const [id, setId] = useState();
  const [name, setName] = useState();
  const [type, setType] = useState(RESTAURANT_TYPE.OTHERS);
  const [address, setAddress] = useState();
  const [distance, setDistance] = useState();
  const [priceFrom, setPriceFrom] = useState();
  const [priceTo, setPriceTo] = useState();
  const [loading, setLoading] = useState(false);
  const { handleOpenToast } = useAppStateContext();

  const resetForm = () => {
    setId();
    setName();
    setType();
    setAddress();
    setDistance();
    setPriceFrom();
    setPriceTo();
    setLoading(false);
  };

  const handleSubmit = async (evt) => {
    evt?.preventDefault?.();
    try {
      setLoading(true);
      const newRestaurant = {
        ...restaurantEditorData,
        id,
        name,
        type,
        address,
        distance: !Number.isNaN(Number(distance)) ? Number(distance) : distance,
        priceFrom,
        priceTo,
      };
      Object.keys(newRestaurant).forEach((key) => {
        if (!newRestaurant?.[key]) {
          delete newRestaurant?.[key];
        }
      });
      await createOrUpdateRestaurant(newRestaurant, (err) => {
        setLoading(false);
        handleOpenToast?.("danger", err?.message);
      });
      resetForm();
      onClose?.();
      handleOpenToast?.(
        "success",
        id ? "Cập nhật thành công!" : "Tạo quán mới thành công!"
      );
    } catch (err) {
      setLoading(false);
      handleOpenToast?.("danger", err?.message);
    }
  };

  useEffect(() => {
    if (open) {
      setId(restaurantEditorData?.id);
      setName(restaurantEditorData?.name);
      setType(restaurantEditorData?.type);
      setAddress(restaurantEditorData?.address);
      setDistance(restaurantEditorData?.distance);
      setPriceFrom(restaurantEditorData?.priceFrom);
      setPriceTo(restaurantEditorData?.priceTo);
    } else {
      resetForm();
    }
  }, [open, restaurantEditorData]);

  if (!open) return null;
  return createPortal(
    <Paper
      className="fixed inset-0 flex items-center justify-center"
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999,
      }}
    >
      <form onSubmit={handleSubmit}>
        <Paper
          onClick={(e) => e.stopPropagation()}
          corner="4"
          width="calc(100vw - 60px)"
          height="50vh"
          background="Se2"
          p="4"
          style={{
            maxHeight: DIALOG_MAX_HEIGHT,
            minHeight: DIALOG_MIN_HEIGHT,
            maxWidth: DIALOG_MAX_WIDTH,
          }}
        >
          <Flex direction="col" style={{ height: "100%" }}>
            <Paper style={{ marginBottom: 48 }}>
              <Flex justify="between">
                <Text size="9" color="i" style={{ fontWeight: 700 }}>
                  {!restaurantEditorData ? "Thêm Quán Mới" : "Cập Nhật Quán"}
                </Text>
                <Paper onClick={onClose}>
                  <IconButton variant="text" icon={<Close />} color="p" />
                </Paper>
              </Flex>
            </Paper>
            <Flex direction="col" gap="5">
              <Input
                variant="bordered"
                placeholder="Tên quán"
                color="i"
                required
                value={name}
                onChange={(evt) => setName(evt?.target?.value)}
              />
              <Select
                variant="bordered"
                placeholder="Loại"
                color="i"
                value={type}
                onChange={(evt) => setType(evt?.target?.value)}
              >
                {RESTAURANT_TYPE_OPTIONS.filter(
                  (opt) => opt.value !== RESTAURANT_TYPE.ALL
                ).map((opt, index) => {
                  return (
                    <option
                      key={`restaurant_type_opt_${index + 1}`}
                      value={opt.value}
                    >
                      <Flex items="center" gap="2">
                        {opt.label}
                      </Flex>
                    </option>
                  );
                })}
              </Select>
              <Input
                variant="bordered"
                placeholder="Địa chỉ"
                color="i"
                required
                value={address}
                onChange={(evt) => setAddress(evt?.target?.value)}
              />
              <InputNumber
                variant="bordered"
                placeholder="Khoảng cách (km)"
                color="i"
                value={distance}
                onChange={(evt) => setDistance(evt?.target?.value)}
              />
              <Flex items="center" gap="4">
                <Text size="5" color="i" weight="5">
                  Giá:
                </Text>
                <Input
                  variant="bordered"
                  placeholder="Nhỏ nhất"
                  color="i"
                  value={priceFrom}
                  onChange={(evt) => setPriceFrom(evt?.target?.value)}
                  suffixInput={",000 VNĐ"}
                />
                {" - "}
                <Input
                  variant="bordered"
                  placeholder="Lớn nhất"
                  color="i"
                  value={priceTo}
                  onChange={(evt) => setPriceTo(evt?.target?.value)}
                  suffixInput={",000 VNĐ"}
                />
              </Flex>
            </Flex>
            <Flex
              items="end"
              justify="end"
              gap="3"
              style={{ flex: 1, marginBottom: 8 }}
            >
              <Button
                variant="solid"
                corner="4"
                color="p"
                style={{ width: 140, height: 40, fontSize: 18 }}
                type="submit"
                state={loading ? "loading" : "idle"}
                loadingText="Đang lưu..."
              >
                {!restaurantEditorData ? "Tạo mới" : "Cập nhật"}
              </Button>
              <Button
                variant="outline"
                corner="4"
                color="p"
                style={{ width: 140, height: 40, fontSize: 18 }}
                onClick={onClose}
              >
                Thoát
              </Button>
            </Flex>
          </Flex>
        </Paper>
      </form>
    </Paper>,
    document.body
  );
};

export default RestaurantEditor;
